import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FeeWaiverTagComponent } from '@features-shared/fee-waiver-tag/fee-waiver-tag.component';
import { TranslateModule } from '@ngx-translate/core';
import { FeeWaiver } from '@shared/types/waivers';
import { FormLabelComponent } from '@ui-kit/form';
import { MultiSelectModule } from 'primeng/multiselect';

@Component({
    selector: 'fee-waivers-dropdown',
    imports: [FormLabelComponent, MultiSelectModule, FeeWaiverTagComponent, FormsModule, TranslateModule],
    templateUrl: './fee-waivers-dropdown.component.html',
    styleUrl: './fee-waivers-dropdown.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeeWaiversDropdownComponent {
    id = input.required<string>();
    placeholder = input.required<string>();
    label = input<string | null>(null);
    feeWaiversOptions = input.required<FeeWaiver[]>();
    value = model.required<number[]>();
    maxSelectedLabels = input<number | null>(null);
    selectedCountLabel = input<string | null>(null);
    truncateSelectedLabels = input<boolean>(false);
    shouldStopPropagation = input<boolean>(false);
    disabled = input<boolean>(false);

    onChange = output<number[]>();
    onClear = output<void>();
    onRemove = output<number>();
}
